module.exports = __webpack_public_path__ + "static/media/executioner-hood.6e796b5c.svg";